<div class="absolute top-[-2.5rem] ml-2 flex">
  @for (item of tabs(); track $index) {
    <button
      class="typo-h5-extralight flex h-10 w-[195px] items-center justify-center leading-none"
      [ngClass]="activeTabIndex() === $index ? 'active-tab bg-background-card font-semibold text-primary-blue' : 'text-text-tertiary'"
      (click)="setActiveTabIndex($index)"
    >
      {{ item.label | translate: { input1: item.count } }}
    </button>
  }
</div>

<div class="min-h-0 flex-1 overflow-hidden">
  @if (isPatientHealthHistoryTabActive()) {
    <lib-health-history-tab></lib-health-history-tab>
  } @else if (isPrescriptionsTabActive()) {
    <lib-prescriptions-tab></lib-prescriptions-tab>
  } @else if (isPatientAlertsTabActive()) {
    <lib-patient-alerts-tab></lib-patient-alerts-tab>
  }
</div>
